import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import {
  consumeAuthTokenFromURL,
  takeResetTokenFromURL,
} from "services/coreapi";

import { router } from "./router";

// Take #token= / #code= out of the URL before anything can record it.
consumeAuthTokenFromURL();
// The reset link carries a one-hour login token in the URL: take it out
// before history records the address.
takeResetTokenFromURL();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} future={{ v7_startTransition: true }} />
  </React.StrictMode>,
);
